import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { LanguageSwitcherContext } from "../context/languageSwitcherContext"

export const useHelloBar = () => {
  const helloBar = useStaticQuery(graphql`
    query HelloBarQuery {
      allDatoCmsHelloBar {
        nodes {
          animate
          title
          locale
          news {
            ... on DatoCmsArticle {
              id
              slug
              locale
              title
              model {
                apiKey
              }

              _allSlugLocales {
                locale
                value
              }
            }
            ... on DatoCmsExternalLink {
              id
              anchor
              model {
                apiKey
              }
              url
            }
          }
        }
      }
    }
  `)

  const locale = React.useContext(LanguageSwitcherContext).activeLocale
  console.log(helloBar)
  const i18nHelloBar = helloBar.allDatoCmsHelloBar.nodes.filter(
    helloBar => helloBar.locale === locale
  )

  return i18nHelloBar[0]
}
